import React, { useContext, useState } from "react";
import Spinner from "react-bootstrap/Spinner";
import "./Shop.css";
import {
  Category,
  CategoryProduct,
  Products,
} from "../../utils/apis/Product/Product";
import { useEffect } from "react";
import Verticle_Categories from "../Near-me/Scan-mart-store/verticle_categories/Verticle_Categories";
import "./Shop.css";
import Top_Filter_Div from "./top_filter_div/Top_Filter_Div";
import { Tab } from "react-bootstrap";
import Product_Info_Card from "../Common-Component/product_info_card/Product_Info_Card";
import Product_Info_Card_2 from "../Common-Component/product_info_card_2/Product_Info_Card_2";
import Product_Info_List_View from "./product_info_list_view/Product_Info_List_View";
import { Context } from "../../utils/context";
import { useLocation } from "react-router-dom";
import { getData } from "../../utils/api";

const Shop = () => {
  const { IMG_URL, shimmerLoader, setShimmerLoader, currentLocation } =
    useContext(Context);
  const [category, setCategory] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [selectedOption, setSelectedOption] = useState("");
  const category_id = queryParams.get("category_id");
  const [selectId, setSelectId] = useState(category_id);
  const category_image = queryParams.get("category_image");
  const productname = queryParams.get("search");

  const subCatId = Number(queryParams.get("sub_category_id"));

  const getCategory = async () => {
    const res = await CategoryProduct();

    if (res?.success) {
      setCategory(res?.data);
    }
  };

  const [products, setProducts] = useState([]);
  const AllProduct = async (category_id) => {
    const city =
      currentLocation?.formatted_address ||
      currentLocation?.city ||
      currentLocation?.formatted_address ||
      currentLocation?.address_components?.[0]?.long_name ||
      "";
    const allproduct = await Products(
      category_id,
      "",
      selectedOption,
      "",
      "",
      productname,
      city,
    );
    if (allproduct?.success) {
      setProducts(allproduct?.data?.data);
    }
  };
  // useEffect(() => {
  //   if (category_id) {
  //     setSelectId(category_id);
  //   }
  // }, [category_id]);

  useEffect(() => {
    AllProduct(selectId);
  }, [selectId, selectedOption, productname, currentLocation]);

  useEffect(() => {
    getCategory();
  }, []);

  // const [currentPage, setCurrentPage] = useState(1);
  // const totalPages = Math.ceil(products?.total_pages);

  // const handlePageChange = (pageNum) => {
  //   if (pageNum >= 1 && pageNum <= totalPages) {
  //     setCurrentPage(pageNum);
  //   }
  // };

  return (
    <section className="Shop near_mart_store">
      <div className="container">
        <Tab.Container id="left-tabs-example" defaultActiveKey="Grid">
          <Top_Filter_Div
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />

          <div className="all_content_holder">
            <div className="left_side">
              <Verticle_Categories
                category_image={category_image}
                category={category}
                setSelectId={setSelectId}
                selectId={selectId}
                // onClick={getProduct}
              />
            </div>

            <div className="right_side_div">
              <Tab.Content>
                <Tab.Pane eventKey="Grid">
                  <div className="row">
                    {loading ? (
                      //  show spinner while loading
                      <div className="spinner-container text-center my-5">
                        <Spinner
                          animation="border"
                          style={{ color: "#235da5" }}
                          variant="primary"
                        />
                      </div>
                    ) : products?.length > 0 ? (
                      products?.map((product) => {
                        return (
                          <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-5 custom_col">
                            <Product_Info_Card_2
                              product={product}
                              showQty
                              image={IMG_URL + product?.image1}
                              product_id={
                                product?.product_variants?.[0]?.product_id
                              }
                              variant_id={product?.product_variants?.[0]?.id}
                              prodname={product?.name}
                              descn={product?.product?.short_description}
                              selling_price={
                                product?.product_variants[0]?.s_price
                              }
                              mrp={product?.product_variants[0]?.mrp}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <div className="noprodiv">
                        <p>No Product Available</p>
                      </div>
                    )}
                  </div>
                  {/* <div className="pagination mt-4 d-flex justify-content-center align-items-center gap-2">
                    <button
                      onClick={() => handlePageChange(1)}
                      disabled={currentPage === 1}
                    >
                      &laquo;
                    </button>
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      &lsaquo;
                    </button>

                  
                    {[currentPage].map((page) => (
                      <button
                        key={page}
                        onClick={() => handlePageChange(page)}
                        className={page === currentPage ? "active" : ""}
                      >
                        {page}
                      </button>
                    ))}
                   
                    {totalPages > 3 && (
                      <>
                        <span>...</span>

                       
                        <button
                          onClick={() => handlePageChange(totalPages)}
                          className={currentPage === totalPages ? "active" : ""}
                        >
                          {totalPages}
                        </button>
                      </>
                    )}

                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      &rsaquo;
                    </button>
                    <button
                      onClick={() => handlePageChange(totalPages)}
                      disabled={currentPage === totalPages}
                    >
                      &raquo;
                    </button>
                  </div> */}
                </Tab.Pane>
                <Tab.Pane eventKey="List">
                  {loading ? (
                    //  show spinner while loading
                    <div className="spinner-container text-center my-5">
                      <Spinner
                        animation="border"
                        style={{ color: "#235da5" }}
                      />
                    </div>
                  ) : products?.length > 0 ? (
                    products.map((product, index) => (
                      <Product_Info_List_View
                        key={index}
                        product={product}
                        showQty
                        image={IMG_URL + product?.image1}
                        product_id={product?.id}
                        variant_id={product?.variant_id}
                        prodname={product?.name}
                        descn={product?.product?.short_description}
                        selling_price={product?.product_variants?.[0]?.s_price}
                        mrp={product?.product_variants?.[0]?.mrp}
                      />
                    ))
                  ) : (
                    <div className="noprodiv">
                      <p>No Product Available</p>
                    </div>
                  )}
                </Tab.Pane>
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    </section>
  );
};

export default Shop;
